import Home from '../pages/Home'
import Login from '../pages/Login'
import Signup from '../pages/SignUp'
import Recovery from '../pages/Recovery'
import AdminLogin from '../pages/Admin/AdminLogin'
import {
  UserCertificateDetails,
  Payments,
  UserBrands,
  Users as Users
} from '../pages/User'
import {
  CertificateDetails,
  Certificates,
  Companies,
  Dashboard,
  Brands,
  BrandDetails,
  Users as AdminUsers,
  Configuration
} from '../pages/Admin'
import Invite from '../pages/SignUp/Invite'
import UserBrandDetails from '../pages/User/Brands/UserBrandDetails'
import Questionary from '../pages/User/Brands/UserBrandDetails/UserCertificates/UserCertificateDetails/Pillars/Questionary'
import NewBrand from '../pages/User/Brands/NewBrand'
import PasswordRedefinition from '../pages/SignUp/PasswordRedefinition'
import Review from '../pages/Admin/Review'
import ReviewCertificates from '../pages/Admin/Review/ReviewCertificates'
import AnswersReview from '../pages/Admin/Review/ReviewCertificates/AnswersReview'

// Default path configuration
export const defaultRoutePath = '/user'
export const defaultAdminRoutePath = '/admin'
export const unauthorizedRoutePath = '/login'
export const unauthorizedAdminRoutePath = '/admin/login'

// By default all routes are private. Use isPrivate: false to make it public
export const routes = [
  {
    id: 'home',
    path: '/',
    name: 'Home',
    component: Home,
    isPrivate: false
  },
  {
    id: 'signUp',
    path: '/signup',
    name: 'SignUp',
    component: Signup,
    isPrivate: false
  },
  {
    id: 'invite',
    path: '/signup/invite',
    name: 'Cadastro através de convite',
    component: Invite,
    isPrivate: false
  },
  {
    id: 'passwordRedefinition',
    path: '/signup/password-redefinition',
    name: 'Redefinir senha',
    component: PasswordRedefinition,
    isPrivate: false
  },
  {
    id: 'login',
    path: '/login',
    name: 'Login',
    component: Login,
    isPrivate: false
  },
  {
    id: 'recovery',
    path: '/recovery',
    name: 'Recuperação de Senha',
    component: Recovery,
    isPrivate: false
  },
  {
    id: 'admin',
    path: '/admin',
    name: 'Admin',
    redirect: '/admin/dashboard'
  },
  {
    id: 'adminLogin',
    path: '/admin/login',
    name: 'Login do Administrador ECBR',
    component: AdminLogin,
    isPrivate: false
  },
  {
    id: 'companies',
    path: '/admin/companies',
    name: 'Empresas',
    component: Companies
  },
  {
    id: 'brand',
    path: '/admin/companies/:id/brands/:id/details',
    name: 'Loja',
    component: BrandDetails
  },

  {
    id: 'dashboard',
    path: '/admin/dashboard',
    name: 'Dashboards',
    component: Dashboard
  },
  {
    id: 'certificates',
    path: '/admin/certificates',
    name: 'Certificados',
    component: Certificates
  },
  {
    id: 'certificateDetails',
    path: '/admin/certificates/:id',
    name: 'Certificado',
    component: CertificateDetails
  },
  {
    id: 'brands',
    path: '/admin/companies/:id/brands',
    name: 'Lojas',
    component: Brands
  },
  {
    id: 'review',
    path: '/admin/review',
    name: 'Revisão',
    component: Review
  },
  {
    id: 'reviewCertificates',
    path: '/admin/review/:id/certificates',
    name: 'Certificados',
    component: ReviewCertificates
  },
  {
    id: 'reviewCertificatesAnswers',
    path: '/admin/review/:id/certificates/:id/answers',
    name: 'Revisão de Respostas',
    component: AnswersReview
  },
  // TODO: remove this temporary route answersReview
  {
    id: 'answersReview',
    path: '/admin/answers-review',
    name: 'Revisão de Respostas',
    component: AnswersReview
  },
  {
    id: 'configuration',
    path: '/admin/configuration',
    name: 'Configurações',
    component: Configuration
  },
  {
    id: 'adminUsers',
    path: '/admin/usuarios',
    name: 'Usuários',
    component: AdminUsers
  },
  {
    id: 'adminUserDetails',
    path: '/admin/usuarios/:id',
    name: 'Usuário',
    component: AdminUsers
  },
  {
    id: 'userQuestionary',
    path: '/user/brands/:id/certificates/:id/questionary/:id',
    name: 'Questionário',
    component: Questionary
  },
  {
    id: 'user',
    path: '/user',
    name: 'User',
    redirect: '/user/brands'
  },
  // {
  //   id: 'userDashboard',
  //   path: '/user/dashboard',
  //   name: 'Dashboard',
  //   component: UserDashBoard,
  //   isPrivate: false
  // },
  {
    id: 'userBrands',
    path: '/user/brands',
    name: 'Lojas',
    component: UserBrands,
    isPrivate: false
  },
  {
    id: 'userBrandDetails',
    path: '/user/brands/:id',
    name: 'Detalhes da loja',
    component: UserBrandDetails
  },
  {
    id: 'UserCertificateDetails',
    path: '/user/brands/:id/certificates/:id',
    name: 'Detalhes do certificado',
    component: UserCertificateDetails
  },
  {
    id: 'payments',
    path: '/user/payments',
    name: 'Pagamentos',
    component: Payments
  },
  {
    id: 'users',
    path: '/user/users',
    name: 'Usuários',
    component: Users
  },
  {
    id: 'newBrand',
    path: '/user/new-brand',
    name: 'Nova loja',
    component: NewBrand
  }
]

const getRoutes = () => {
  const routesObj = {}
  routes.forEach((route) => {
    routesObj[route.name] = route.path
  })
  return routesObj
}

export const routePaths = getRoutes()

export const defaultRoute = routes
  .filter((route) => route.path === defaultRoutePath)
  .shift()

export const defaultAdminRoute = routes
  .filter((route) => route.path === defaultAdminRoutePath)
  .shift()

export const unauthorizedRoute = routes
  .filter((route) => route.path === unauthorizedRoutePath)
  .shift()

export const unauthorizedAdminRoute = routes
  .filter((route) => route.path === unauthorizedAdminRoutePath)
  .shift()
